import { withHook } from 'utils/withHook';

import { useSignInPageLogic } from 'pages/SignInPage/SignInPage.logic';
import { SignInPageView } from 'pages/SignInPage/SignInPage.view';

export const SignInPage = withHook(useSignInPageLogic)(SignInPageView);
